import { Link } from "react-router-dom";
import { site, categories, navLinks } from "@/mocks/content";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">吃瓜日报</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {site.description}
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-300">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-line text-base text-secondary-400" aria-hidden="true" />
              </span>
              {site.email}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              瓜料分类
            </h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/topic/${category.slug}`}
                    className="text-sm text-background-300 transition-colors duration-200 hover:text-primary-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              站内导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors duration-200 hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about#tips"
                  className="text-sm text-background-300 transition-colors duration-200 hover:text-primary-300"
                >
                  爆料投稿
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              内容原则
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li>只整理公开可查的信息</li>
              <li>明确标注待确认内容</li>
              <li>不发布个人隐私信息</li>
              <li>支持当事人申请更正</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {year} 吃瓜日报 · 吃瓜有度，理性围观
          </p>
          <p className="text-xs text-background-400">
            本站内容均为公开信息整理，如涉侵权请联系站长处理
          </p>
        </div>
      </div>
    </footer>
  );
}